import React from 'react';
import type { FieldConfigurationComponentProps } from '../../../../types.tsx';
import type { AssociatedField } from '../../../../types/layout-items.tsx';
import { FieldOptions } from '../field-options/index.tsx';
import { isDefaultOption, refineDefaultValue } from '../field-options/view.tsx';
import { DefaultValueControlRight } from './default-value/view.tsx';
import messages from './messages.tsx';

const onFieldUpdate =
	(onUpdate: (newField: AssociatedField) => void) =>
	(field: AssociatedField): void => {
		const { defaultValue, options } = field;

		if (options == null) {
			return onUpdate(field);
		}
		const refined = refineDefaultValue(defaultValue);
		if (refined.length === 0) {
			return onUpdate(field);
		}
		return onUpdate({
			...field,
			defaultValue: options.find(isDefaultOption(refined)),
		});
	};

export const DropdownFieldConfiguration = (props: FieldConfigurationComponentProps) => (
	<FieldOptions
		{...props}
		label={messages.optionsLabel}
		onUpdate={onFieldUpdate(props.onUpdate)}
		DefaultValueControlRight={DefaultValueControlRight}
	/>
);
